import { respondentsSlice } from './slice';

export * from './state';

const Actions = respondentsSlice.actions;
const Reducer = respondentsSlice.reducer;

export { Reducer, Actions };
